import Navbar from "react-bootstrap/Navbar";
import Dropdown from "react-bootstrap/Dropdown";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import { useSelector } from "react-redux";
import { SUPERUSER_INDEXES } from "../pages/assessments/AnnualReviewExtras";
// import { useSelector } from "react-redux";

// import ArNav from "./navigation/ArNav";
// import WipNav from "./navigation/WipNav";
// import BillNav from "./navigation/BillNav";
// import HrNav from "./navigation/HrNav";
import PowerBINav from "./navigation/PowerBINav";
import PeopleNav from "./navigation/PeopleNav";
import "primeicons/primeicons.css";
import NCTONav from "./navigation/NCTONav";
import { HelpMarker } from "./Help";
import { TableStatusDisplay } from './TableStatusDisplay';
import { SignOutButton } from "../pages/home/Logout";
/**
 * Renders the navbar component with a sign in or sign out button depending on whether or not a user is authenticated
 * @param props
 */
export const PageLayout = ({ setShowHelp, children }) => {
    const { POWER_BI, STAFFMANAGER, DEPARTMENT, STAFFINDEX, TEAM_LEAD, ASSESS_AVAILABLE, SUPERVISOR_ASSESS_AVAILABLE, TEAM_LEAD_ASSESS_AVAILABLE } = useSelector(state => state.user);
    const REVIEW_ACCESS = DEPARTMENT === 'Tax' || DEPARTMENT === 'TAX' || DEPARTMENT === 'OAS' || SUPERUSER_INDEXES.includes(STAFFINDEX) || DEPARTMENT === 'Advisory' || DEPARTMENT === 'ADVISORY';
    const REVIEW_TEST_GROUP = [11488, 15118, 109, 113, 128, 310, 316];
    const REVIEW_NAV = REVIEW_ACCESS || ASSESS_AVAILABLE === 1 || SUPERVISOR_ASSESS_AVAILABLE === 1 || TEAM_LEAD_ASSESS_AVAILABLE === 1
    console.log(DEPARTMENT);
    return (
        <>
            <Navbar
                expand="lg"
                variant="dark"
                className="navbarStyle primary-bg brand-text brand-gradient"
            >
                <Container>
                    <Navbar.Brand href="/">
                        <img
                            src="/Magnify-21.png"
                            width="130px"
                            alt="Magnify logo on blue and white background, representing a brand with a sleek and modern design."
                        // height="10px"
                        />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <div className="d-flex justify-content-between align-items-center w-100">
                            <Nav>
                                <Nav.Link href="/" className="brand-text">
                                    Home
                                </Nav.Link>
                                {POWER_BI === 1 && <Dropdown variant="primary-bg brand-text">
                                    <Dropdown.Toggle variant="primary-bg brand-text">
                                        Magnify Reports
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu >
                                        {/* <ArNav />
                        <WipNav />
                        <BillNav />
                        {/* <HrNav /> */}
                                        <PowerBINav />
                                    </Dropdown.Menu>
                                </Dropdown>}
                                {/* <Dropdown>
                        <Dropdown.Toggle variant="primary-bg brand-text">
                            Magnify People
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item href="/people/reviews">Reviews</Dropdown.Item>
                            <Dropdown.Item href="/people/requests">Requests</Dropdown.Item>
                            <Dropdown.Item href="/people/morale">Morale</Dropdown.Item>
                        </Dropdown.Menu>
                        
                    </Dropdown> */}
                                {/* <Dropdown>
                        <Dropdown.Toggle variant="primary-bg brand-text">
                            Magnify Apps
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item href="/apps/ncto">New Client Take On</Dropdown.Item>
                            <Dropdown.Item href="/apps/bingo">Bingo</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>  */}
                                <PeopleNav />
                                <Dropdown>
                                    <Dropdown.Toggle variant="primary-bg brand-text">
                                        Magnify Clients
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <NCTONav />
                                    </Dropdown.Menu>
                                </Dropdown>
                                
                                <Dropdown>
                                    <Dropdown.Toggle variant="primary-bg brand-text">
                                        Annual Review
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item href={`/annual-review/historical/${STAFFINDEX}`}>Historical Reviews</Dropdown.Item>
                                        <Dropdown.Item href="/annual-review/supervisor-view">My Staff Historical</Dropdown.Item>
                                        {REVIEW_NAV && ((DEPARTMENT === 'Tax' || DEPARTMENT === 'OAS' || DEPARTMENT.toUpperCase() === 'ADVISORY' || (SUPERUSER_INDEXES.includes(STAFFINDEX)) ) && (ASSESS_AVAILABLE === 1)) && <Dropdown.Item href="/annual-review">My Annual Review</Dropdown.Item>}

                                        {REVIEW_NAV && (SUPERVISOR_ASSESS_AVAILABLE === 1) && <Dropdown.Item href="/annual-review?type=supervisor">Supervisor Review</Dropdown.Item>}
                                        {/* {(SUPERVISOR_ASSESS_AVAILABLE === 1) && <Dropdown.Item href="/annual-review/supervisor-view">My Staff Historical</Dropdown.Item>} */}
                                        {REVIEW_NAV && (TEAM_LEAD || TEAM_LEAD_ASSESS_AVAILABLE === 1) && <Dropdown.Item href="/annual-review?type=teamlead">My Team Reviews</Dropdown.Item>}

                                        {(SUPERUSER_INDEXES.includes(STAFFINDEX)) && <Dropdown.Item href="/annual-review?type=all">Firm Reviews</Dropdown.Item>}
                                        {/* <Dropdown.Item href="/annual-review-2024">Supervisor Reviews</Dropdown.Item> */}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Nav>
                            <div className="d-flex align-items-center">
                                <HelpMarker
                                    className={"help-button"}
                                    icon="pi-question"
                                    showCallBack={() => setShowHelp(true)}
                                >
                                    <span>Help</span>
                                </HelpMarker>
                                <TableStatusDisplay />
                                <SignOutButton />
                            </div>
                        </div>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            {children}
        </>
    );
};

export const NonUserLayout = ({ setShowHelp, children }) => {
    return (
        <>
            <Navbar
                expand="lg"
                variant="dark"
                className="navbarStyle primary-bg brand-text brand-gradient"
            >
                <Container>
                    <Navbar.Brand href="/">
                        <img
                            src="/Magnify-21.png"
                            width="130px"
                            alt="Magnify logo on blue and white background, representing a brand with a sleek and modern design."
                        // height="10px"
                        />
                    </Navbar.Brand>
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav">
                        <Nav>
                            <Nav.Link href="/" className="brand-text">
                                Home
                            </Nav.Link>
                        </Nav>
                        <HelpMarker
                            className={"help-button"}
                            icon="pi-question"
                            showCallBack={() => setShowHelp(true)}
                        >
                            <span>Help</span>
                        </HelpMarker>
                    </Navbar.Collapse>
                </Container>
            </Navbar>
            {children}
        </>
    );
}
